import { Container } from 'aurelia-framework';
import { GeneralEnumsApi } from 'api/general-enums';
import { GeneralIdentityApi } from 'api/general-identity';
import { GeneralKeywordsApi } from 'api/general-keywords';
import { GeneralLookupsApi } from 'api/general-lookups';
import { GeneralCountriesApi } from 'api/general-countries';
import { TravelRequestDetailApi } from 'api/travel-request-detail';
import { TravelRequestsListApi } from 'api/travel-requests-list';
import { HolidayTripDetailApi } from 'api/holiday-trip-detail';
import { HolidayTripsListApi } from 'api/holiday-trips-list';
import { VariousReportsApi } from 'api/various-reports';
import { GeneralEnumsClientApi } from '../general-enums-client';
import { GeneralIdentityClientApi } from '../general-identity-client';
import { GeneralKeywordsClientApi } from '../general-keywords-client';
import { GeneralLookupsClientApi } from '../general-lookups-client';
import { GeneralCountriesClientApi } from '../general-countries-client';
import { TravelRequestsListClientApi } from '../travel-requests-list-client';
import { HolidayTripDetailClientApi } from '../holiday-trip-detail-client';
import { HolidayTripsListClientApi } from '../holiday-trips-list-client';
import { TravelRequestDetailClientApi } from '../travel-request-detail-client';
import { VariousReportsClientApi } from '../various-reports-client';
import { DeviationRequestsListClientApi } from '../deviation-requests-list-client';
import { DeviationRequestsListApi } from 'api/deviation-requests-list';
import { DeviationRequestDetailApi } from 'api/deviation-request-detail';
import { DeviationRequestDetailClientApi } from '../deviation-request-detail-client';

export function configure(container: Container) {
  registerHandler(container, GeneralEnumsApi, GeneralEnumsClientApi);
  registerHandler(container, GeneralIdentityApi, GeneralIdentityClientApi);
  registerHandler(container, GeneralKeywordsApi, GeneralKeywordsClientApi);
  registerHandler(container, GeneralLookupsApi, GeneralLookupsClientApi);
  registerHandler(container, GeneralCountriesApi, GeneralCountriesClientApi);
  registerHandler(container, TravelRequestDetailApi, TravelRequestDetailClientApi);
  registerHandler(container, TravelRequestsListApi, TravelRequestsListClientApi);
  registerHandler(container, HolidayTripDetailApi, HolidayTripDetailClientApi);
  registerHandler(container, HolidayTripsListApi, HolidayTripsListClientApi);
  registerHandler(container, VariousReportsApi, VariousReportsClientApi);
  registerHandler(container, DeviationRequestsListApi, DeviationRequestsListClientApi);
  registerHandler(container, DeviationRequestDetailApi, DeviationRequestDetailClientApi);
}

function registerHandler(container: Container, definition, implementation) {
  container.unregister(definition);
  container.registerHandler(definition, c => c.get(implementation));
}
